import { css } from '@emotion/css';
import { theme } from '../../electrons/Theme/Theme.constants';
const label = css `
  font-size: 14px;
  margin-left: -6px;
  color: ${theme.palette.text.primary};
`;
export const RadioGroupStyles = {
    label,
};
//# sourceMappingURL=RadioGroup.styles.js.map